/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { Transaction } from './Transaction';
import {
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
    TransactionToJSONTyped,
} from './Transaction';

/**
 * 
 * @export
 * @interface TransactionsPaginated
 */
export interface TransactionsPaginated {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof TransactionsPaginated
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof TransactionsPaginated
     */
    data: Array<Transaction>;
}

/**
 * Check if a given object implements the TransactionsPaginated interface.
 */
export function instanceOfTransactionsPaginated(value: object): value is TransactionsPaginated {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function TransactionsPaginatedFromJSON(json: any): TransactionsPaginated {
    return TransactionsPaginatedFromJSONTyped(json, false);
}

export function TransactionsPaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsPaginated {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'data': ((json['data'] as Array<any>).map(TransactionFromJSON)),
    };
}

export function TransactionsPaginatedToJSON(json: any): TransactionsPaginated {
    return TransactionsPaginatedToJSONTyped(json, false);
}

export function TransactionsPaginatedToJSONTyped(value?: TransactionsPaginated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'data': ((value['data'] as Array<any>).map(TransactionToJSON)),
    };
}

